<template lang="pug">
.container
  .card
    cadastro-sicarf(titleCadastro="Regularização de áreas patrimoniais", routeName="areasPatrimoniais", :cadastroEmpty="empty", :tabs="tabs")
</template>

<script>
import CadastroSicarf from '@/screens/central/components/CadastroSicarf'
import empty from '../empty/emptyAreasPatrimoniais'

export default {

  components: {
    CadastroSicarf
  },

  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: [
        {
          label: 'Cadastrante',
          name: 'areasPatrimoniais/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: 'areasPatrimoniais/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Georreferenciamento',
          name: 'areasPatrimoniais/georreferenciamento',
          codigo: 'GEORREFERENCIAMENTO'
        },
        {
          label: 'Resumo',
          name: 'areasPatrimoniais/resumo',
          isResumo: true
        }
      ],
      empty: empty
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/areasPatrimoniais/Cadastro.vue